import React from "react";

// pass { id } prop when using case "refersh", with appropriate id
const SvgIcons = ({ type, id }) => {
  switch (type) {
    case "phone": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="23"
            viewBox="0 0 24 23"
          >
            <defs>
              <clipPath id="clipPath">
                <rect
                  id="Rectangle_5"
                  data-name="Rectangle 5"
                  width="24"
                  height="23"
                  transform="translate(-1)"
                  fill="#16346c"
                />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_2"
              data-name="Mask Group 2"
              transform="translate(1)"
              clipPath="url(#clipPath)"
            >
              <path
                id="phone-call_11_"
                data-name="phone-call (11)"
                d="M12.479.96a.96.96,0,0,1,.96-.96,9.61,9.61,0,0,1,9.6,9.6.96.96,0,1,1-1.92,0A7.688,7.688,0,0,0,13.439,1.92a.96.96,0,0,1-.96-.96Zm.96,4.8a3.84,3.84,0,0,1,3.84,3.84.96.96,0,1,0,1.92,0A5.765,5.765,0,0,0,13.439,3.84a.96.96,0,1,0,0,1.92Zm8.728,10.308a2.976,2.976,0,0,1,0,4.2l-.874,1.007C13.432,28.8-5.7,9.678,1.711,1.791l1.1-.96A2.957,2.957,0,0,1,6.969.87C7,.9,8.777,3.21,8.777,3.21a2.976,2.976,0,0,1-.007,4.11l-1.112,1.4a12.268,12.268,0,0,0,6.653,6.666l1.406-1.118a2.976,2.976,0,0,1,4.109-.006S22.137,16.038,22.167,16.068Zm-1.321,1.4s-2.3-1.767-2.327-1.8a1.056,1.056,0,0,0-1.487,0c-.026.027-1.962,1.569-1.962,1.569a.96.96,0,0,1-.94.146A14.407,14.407,0,0,1,5.663,8.927a.96.96,0,0,1,.139-.96S7.345,6.03,7.371,6.005a1.056,1.056,0,0,0,0-1.487c-.03-.029-1.8-2.328-1.8-2.328a1.056,1.056,0,0,0-1.449.037l-1.1.96C-2.395,9.7,14.183,25.359,19.89,19.966l.874-1.008a1.076,1.076,0,0,0,.082-1.495Z"
                transform="translate(-0.465 0.002)"
                fill="#16346c"
              />
            </g>
          </svg>
        </>
      );
    }
    case "email": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="23"
            viewBox="0 0 24 23"
          >
            <defs>
              <clipPath id="clipPath">
                <rect
                  id="Rectangle_6"
                  data-name="Rectangle 6"
                  width="24"
                  height="23"
                  transform="translate(-1)"
                  fill="#16346c"
                />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_3"
              data-name="Mask Group 3"
              transform="translate(1)"
              clipPath="url(#clipPath)"
            >
              <path
                id="at_3_"
                data-name="at (3)"
                d="M11.5,0A11.509,11.509,0,0,0,0,11.5C-.121,20.668,10.691,26.278,18.107,20.9A.958.958,0,1,0,17,19.336c-6.177,4.477-15.183-.2-15.087-7.84.526-12.709,18.637-12.707,19.161,0v1.916a1.916,1.916,0,0,1-3.832,0V11.5C17,3.9,5.989,3.9,5.748,11.5a5.765,5.765,0,0,0,10.079,3.768,3.832,3.832,0,0,0,7.166-1.852V11.5A11.509,11.509,0,0,0,11.5,0Zm0,15.329A3.832,3.832,0,1,1,15.329,11.5,3.832,3.832,0,0,1,11.5,15.329Z"
                transform="translate(-0.423)"
                fill="#16346c"
              />
            </g>
          </svg>
        </>
      );
    }
    case "linkdin": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="23"
            viewBox="0 0 23 23"
          >
            <defs>
              <clipPath id="clipPath">
                <rect
                  id="Rectangle_7"
                  data-name="Rectangle 7"
                  width="23"
                  height="23"
                  fill="#16346c"
                />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_4"
              data-name="Mask Group 4"
              clipPath="url(#clipPath)"
            >
              <g
                id="linkedin_3_"
                data-name="linkedin (3)"
                transform="translate(-0.427 0.512)"
              >
                <path
                  id="Path_1"
                  data-name="Path 1"
                  d="M29.149,20.125v8.113a.377.377,0,0,1-.37.37H24.594a.377.377,0,0,1-.37-.37V20.694c0-1.993-.712-3.359-2.5-3.359a2.71,2.71,0,0,0-2.533,1.793,3.116,3.116,0,0,0-.171,1.2v7.913a.377.377,0,0,1-.37.37H14.489a.377.377,0,0,1-.37-.37c0-2.021.057-11.785,0-14.062a.377.377,0,0,1,.37-.37h4.184a.377.377,0,0,1,.37.37v1.736c0,.028-.028.028-.028.057h.028v-.057a4.913,4.913,0,0,1,4.441-2.448C26.729,13.464,29.149,15.6,29.149,20.125ZM6.832,28.636h4.184a.377.377,0,0,0,.37-.37V14.176a.377.377,0,0,0-.37-.37H6.832a.377.377,0,0,0-.37.37v14.09a.4.4,0,0,0,.37.37Z"
                  transform="translate(-6.149 -6.661)"
                  fill="#16346c"
                />
                <circle
                  id="Ellipse_4"
                  data-name="Ellipse 4"
                  cx="2.647"
                  cy="2.647"
                  r="2.647"
                  fill="#16346c"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "backArrow": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-left"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </>
      );
    }
    case "notification": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
          >
            <g
              id="Group_37764"
              data-name="Group 37764"
              transform="translate(0 0)"
            >
              <rect
                id="Rectangle_16"
                data-name="Rectangle 16"
                width="17"
                height="17"
                transform="translate(0 0)"
                fill="none"
              />
              <g
                id="Group_24"
                data-name="Group 24"
                transform="translate(0.754 0.888)"
              >
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M15.341,13.118h1.482V14.6H2V13.118H3.482V7.93a5.93,5.93,0,1,1,11.859,0Zm-1.482,0V7.93a4.447,4.447,0,1,0-8.894,0v5.188ZM7.188,16.083h4.447v1.482H7.188Z"
                  transform="translate(-2 -2)"
                  stroke-width="0.2"
                />
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "setting": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-settings fillNone"
          >
            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        </>
      );
    }
    case "pencil": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-pencil"
          >
            <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
            <path d="m15 5 4 4" />
          </svg>
        </>
      );
    }
    case "filterIcon": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-sliders-horizontal"
          >
            <line x1="21" x2="14" y1="4" y2="4" />
            <line x1="10" x2="3" y1="4" y2="4" />
            <line x1="21" x2="12" y1="12" y2="12" />
            <line x1="8" x2="3" y1="12" y2="12" />
            <line x1="21" x2="16" y1="20" y2="20" />
            <line x1="12" x2="3" y1="20" y2="20" />
            <line x1="14" x2="14" y1="2" y2="6" />
            <line x1="8" x2="8" y1="10" y2="14" />
            <line x1="16" x2="16" y1="18" y2="22" />
          </svg>
        </>
      );
    }
    case "refersh": {
      return (
        <>
          <svg
            id={id}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-refresh-ccw"
          >
            <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
            <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
            <path d="M16 16h5v5" />
          </svg>
        </>
      );
    }
    case "editIcon": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.822"
            height="14.698"
            viewBox="0 0 14.822 14.698"
          >
            <g
              id="Group_38886"
              data-name="Group 38886"
              transform="translate(-1876.602 -260.7)"
            >
              <rect
                id="Rectangle_13322"
                data-name="Rectangle 13322"
                width="13.835"
                height="13.835"
                transform="translate(1877 261)"
                fill="none"
              />
              <path
                id="_728966_edit_pen_pencil_writing_draw_icon"
                data-name="728966_edit_pen_pencil_writing_draw_icon"
                d="M13.488,1.75,12.25.513a1.75,1.75,0,0,0-2.475,0L2.262,8.025A6.26,6.26,0,0,0,.875,10.137L0,14l3.862-.875a21.319,21.319,0,0,0,2.112-1.388l7.513-7.513A1.75,1.75,0,0,0,13.488,1.75ZM1.16,12.84l.568-2.51a.868.868,0,0,0,.018-.109c0-.005.006-.013.009-.018l1.979,1.979-.2.12Zm4.2-1.723a8.706,8.706,0,0,1-.86.592L2.23,9.442a7.857,7.857,0,0,1,.651-.8L8.538,2.987l2.475,2.475Zm7.511-7.511L11.631,4.843,9.157,2.369l1.238-1.237a.875.875,0,0,1,1.237,0l1.237,1.237a.875.875,0,0,1,0,1.237Z"
                transform="translate(1877 261)"
                fill="#4b96cd"
                stroke="#4b96cd"
                stroke-width="0.6"
              />
            </g>
          </svg>
        </>
      );
    }

    // routes
    case "masterSchedule": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_1"
                  data-name="Rectangle 1"
                  width="200"
                  height="200"
                  transform="translate(41 53)"
                  // fill=""
                  // stroke="red"
                  // stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="masterschedule"
              transform="translate(-41 -53)"
              // clip-path="url(#clip-path)"
            >
              <path
                id="calendar-clock_2_"
                data-name="calendar-clock (2)"
                d="M145.833,91.992A54,54,0,1,0,200,145.833,54.229,54.229,0,0,0,145.833,91.992Zm0,99.675a45.671,45.671,0,1,1,45.833-45.833A45.728,45.728,0,0,1,145.833,191.667Zm11.283-40.45a4.169,4.169,0,0,1-5.9,5.892l-8.333-8.333a4.161,4.161,0,0,1-1.217-2.95V129.158a4.167,4.167,0,0,1,8.333,0V144.1ZM162.5,16.667H150V4.167a4.167,4.167,0,0,0-8.333,0v12.5H58.333V4.167a4.167,4.167,0,1,0-8.333,0v12.5H37.5A37.546,37.546,0,0,0,0,54.167V162.5A37.546,37.546,0,0,0,37.5,200h50a4.167,4.167,0,0,0,0-8.333h-50A29.2,29.2,0,0,1,8.333,162.5V75H191.667V87.5a4.167,4.167,0,0,0,8.333,0V54.167A37.546,37.546,0,0,0,162.5,16.667Zm-154.167,50v-12.5A29.2,29.2,0,0,1,37.5,25h125a29.2,29.2,0,0,1,29.167,29.167v12.5Z"
                transform="translate(41 53)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "orderDashboard": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_19"
                  data-name="Rectangle 19"
                  width="200"
                  height="200"
                  transform="translate(41 537)"
                  fill="#fff"
                  stroke="red"
                  stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Dashboard"
              transform="translate(-41 -537)"
              // clip-path="url(#clip-path)"
            >
              <g id="analytics_238057" transform="translate(41 537)">
                <g id="Group_26" data-name="Group 26">
                  <g id="Group_25" data-name="Group 25">
                    <path
                      id="Path_13"
                      data-name="Path 13"
                      d="M126.667,173.333H73.333A16.5,16.5,0,0,0,56.666,190,3.149,3.149,0,0,0,60,193.333h80A3.149,3.149,0,0,0,143.333,190,16.5,16.5,0,0,0,126.667,173.333ZM64,186.667A9.71,9.71,0,0,1,73.333,180H127a9.71,9.71,0,0,1,9.333,6.667Z"
                    />
                  </g>
                </g>
                <g id="Group_28" data-name="Group 28">
                  <g id="Group_27" data-name="Group 27">
                    <path
                      id="Path_14"
                      data-name="Path 14"
                      d="M126.667,176,120,149.333a3.246,3.246,0,0,0-3.333-2.667H83.334A3.588,3.588,0,0,0,80,149.333L73.334,176A3.591,3.591,0,0,0,74,178.667,3.032,3.032,0,0,0,76.667,180h46.667A3.785,3.785,0,0,0,126,179,3.4,3.4,0,0,0,126.667,176ZM81,173.333l5-20h28l5,20Z"
                    />
                  </g>
                </g>
                <g id="Group_30" data-name="Group 30">
                  <g id="Group_29" data-name="Group 29">
                    <path
                      id="Path_15"
                      data-name="Path 15"
                      d="M185,6.667H15a14.938,14.938,0,0,0-15,15V123.334a3.149,3.149,0,0,0,3.333,3.333H196.666A3.149,3.149,0,0,0,200,123.334V21.667A14.937,14.937,0,0,0,185,6.667ZM193.333,120H6.667V21.667A8.252,8.252,0,0,1,15,13.334H185a8.252,8.252,0,0,1,8.333,8.333Z"
                    />
                  </g>
                </g>
                <g id="Group_32" data-name="Group 32">
                  <g id="Group_31" data-name="Group 31">
                    <path
                      id="Path_16"
                      data-name="Path 16"
                      d="M196.667,120H3.333A3.149,3.149,0,0,0,0,123.333v15a14.938,14.938,0,0,0,15,15H185a14.938,14.938,0,0,0,15-15v-15A3.149,3.149,0,0,0,196.667,120Zm-3.334,18.333A8.252,8.252,0,0,1,185,146.666H15a8.252,8.252,0,0,1-8.333-8.333V126.666H193.334v11.667Z"
                    />
                  </g>
                </g>
                <g id="Group_34" data-name="Group 34">
                  <g id="Group_33" data-name="Group 33">
                    <path
                      id="Path_17"
                      data-name="Path 17"
                      d="M113.333,96.667A3.149,3.149,0,0,0,110,100v10a3.333,3.333,0,0,0,6.666,0V100A3.149,3.149,0,0,0,113.333,96.667Z"
                    />
                  </g>
                </g>
                <g id="Group_36" data-name="Group 36">
                  <g id="Group_35" data-name="Group 35">
                    <path
                      id="Path_18"
                      data-name="Path 18"
                      d="M126.667,83.333a3.149,3.149,0,0,0-3.333,3.333V110A3.333,3.333,0,0,0,130,110V86.667A3.149,3.149,0,0,0,126.667,83.333Z"
                    />
                  </g>
                </g>
                <g id="Group_38" data-name="Group 38">
                  <g id="Group_37" data-name="Group 37">
                    <path
                      id="Path_19"
                      data-name="Path 19"
                      d="M140,90a3.149,3.149,0,0,0-3.333,3.333V110a3.333,3.333,0,1,0,6.666,0V93.333A3.149,3.149,0,0,0,140,90Z"
                    />
                  </g>
                </g>
                <g id="Group_40" data-name="Group 40">
                  <g id="Group_39" data-name="Group 39">
                    <path
                      id="Path_20"
                      data-name="Path 20"
                      d="M153.333,66.667A3.149,3.149,0,0,0,150,70v40a3.333,3.333,0,1,0,6.666,0V70A3.149,3.149,0,0,0,153.333,66.667Z"
                    />
                  </g>
                </g>
                <g id="Group_42" data-name="Group 42">
                  <g id="Group_41" data-name="Group 41">
                    <path
                      id="Path_21"
                      data-name="Path 21"
                      d="M166.667,80a3.149,3.149,0,0,0-3.333,3.333V110A3.333,3.333,0,0,0,170,110V83.333A3.149,3.149,0,0,0,166.667,80Z"
                    />
                  </g>
                </g>
                <g id="Group_44" data-name="Group 44">
                  <g id="Group_43" data-name="Group 43">
                    <path
                      id="Path_22"
                      data-name="Path 22"
                      d="M58.333,26.667A38.333,38.333,0,1,0,96.666,65,38.554,38.554,0,0,0,58.333,26.667Zm0,70A31.667,31.667,0,1,1,90,65,31.868,31.868,0,0,1,58.333,96.667Z"
                    />
                  </g>
                </g>
                <g id="Group_46" data-name="Group 46">
                  <g id="Group_45" data-name="Group 45">
                    <path
                      id="Path_23"
                      data-name="Path 23"
                      d="M85.667,38a39.425,39.425,0,0,0-29-11.333A3.418,3.418,0,0,0,53.334,30V66.667A3.34,3.34,0,0,0,56.667,70H93.334A10.294,10.294,0,0,0,96,69.333,3.026,3.026,0,0,0,97,67,38.923,38.923,0,0,0,85.667,38ZM60,63.333v-30a30.539,30.539,0,0,1,20.667,9.333A30.537,30.537,0,0,1,90,63.333Z"
                    />
                  </g>
                </g>
                <g id="Group_48" data-name="Group 48">
                  <g id="Group_47" data-name="Group 47">
                    <path
                      id="Path_24"
                      data-name="Path 24"
                      d="M83.667,89,59,64.333A3.3,3.3,0,0,0,54.333,69L79,93.667a3.222,3.222,0,0,0,4.666,0A3.222,3.222,0,0,0,83.667,89Z"
                    />
                  </g>
                </g>
                <g id="Group_50" data-name="Group 50">
                  <g id="Group_49" data-name="Group 49">
                    <path
                      id="Path_25"
                      data-name="Path 25"
                      d="M150,40H123.333a3.333,3.333,0,0,0,0,6.666H150A3.333,3.333,0,1,0,150,40Z"
                    />
                  </g>
                </g>
                <g id="Group_52" data-name="Group 52">
                  <g id="Group_51" data-name="Group 51">
                    <path
                      id="Path_26"
                      data-name="Path 26"
                      d="M169.333,41c-.333,0-.333-.333-.667-.333s-.333-.333-.667-.333c-.333-.333-.333-.333-.667-.333a4.653,4.653,0,0,0-3,1,3.026,3.026,0,0,0-1,2.333c0,.667.333,1,.333,1.333s.333.667.667,1a3.026,3.026,0,0,0,2.333,1h.667c.333-.333.333-.333.667-.333a32814165563729.8,32814165563729.8,0,0,1,1.334-.666c.333-.333.333-.667.667-1a2,2,0,0,0,.333-1.333A3.026,3.026,0,0,0,169.333,41Z"
                    />
                  </g>
                </g>
                <g id="Group_54" data-name="Group 54">
                  <g id="Group_53" data-name="Group 53">
                    <path
                      id="Path_27"
                      data-name="Path 27"
                      d="M166.667,23.333h-10a3.149,3.149,0,0,0-3.333,3.333A3.149,3.149,0,0,0,156.667,30h10A3.149,3.149,0,0,0,170,26.666,3.149,3.149,0,0,0,166.667,23.333Z"
                    />
                  </g>
                </g>
                <g id="Group_56" data-name="Group 56">
                  <g id="Group_55" data-name="Group 55">
                    <path
                      id="Path_28"
                      data-name="Path 28"
                      d="M130,23.333h-6.667A3.149,3.149,0,0,0,120,26.666,3.149,3.149,0,0,0,123.333,30H130a3.149,3.149,0,0,0,3.333-3.333A3.149,3.149,0,0,0,130,23.333Z"
                    />
                  </g>
                </g>
                <g id="Group_58" data-name="Group 58">
                  <g id="Group_57" data-name="Group 57">
                    <path
                      id="Path_29"
                      data-name="Path 29"
                      d="M146,24.333c-.333,0-.333-.333-.667-.333s-.333-.333-.667-.333c-.333-.333-.333-.333-.667-.333h-1.333c-.333.333-.333.333-.667.333s-.333.333-.667.333l-.333.333c-.333.333-.667.667-.667,1A2,2,0,0,0,140,26.666,3.025,3.025,0,0,0,141,29l.333.333c.333,0,.333.333.667.333.333.333.333.333.667.333h1c.333-.333.333-.333.667-.333a1.163,1.163,0,0,0,.667-.333,1.165,1.165,0,0,0,.667-.333,3.026,3.026,0,0,0,1-2.333V25.333C146.667,25,146.333,24.667,146,24.333Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "agent": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_2"
                  data-name="Rectangle 2"
                  width="200"
                  height="200"
                  transform="translate(268 53)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Agent"
              transform="translate(-268 -53)"
              // clip-path="url(#clip-path)"
            >
              <path
                id="boss"
                d="M100,83.333A41.667,41.667,0,1,0,58.333,41.667,41.714,41.714,0,0,0,100,83.333Zm0-75A33.333,33.333,0,1,1,66.667,41.667,33.367,33.367,0,0,1,100,8.333ZM200,166.667H166.667v-37.5a37.546,37.546,0,0,0-37.5-37.5H70.833a37.546,37.546,0,0,0-37.5,37.5v37.5H0V175H16.667v25H25V175H175v25h8.333V175H200Zm-41.667-37.5v37.5H119.917L108.65,121.608,123.058,100h6.1a29.2,29.2,0,0,1,29.167,29.167ZM100,119.575,86.95,100h26.1Zm0,1.767,11.333,45.325H88.667L100,121.342Zm-58.333,7.825A29.2,29.2,0,0,1,70.833,100h6.1l14.408,21.608L80.075,166.667H41.658v-37.5Z"
                transform="translate(268 53)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "accounting": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_18"
                  data-name="Rectangle 18"
                  width="200"
                  height="200"
                  transform="translate(41 537)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Accounting"
              transform="translate(-41 -537)"
              // clip-path="url(#clip-path)"
            >
              <g id="calculator_548606" transform="translate(41 537)">
                <g id="Group_14" data-name="Group 14">
                  <g id="Group_13" data-name="Group 13">
                    <path
                      id="Path_7"
                      data-name="Path 7"
                      d="M195.775,39.434a4.225,4.225,0,0,0-4.225,4.225V95.775H104.225V8.451h74.648A12.691,12.691,0,0,1,191.55,21.127a4.225,4.225,0,1,0,8.45,0A21.151,21.151,0,0,0,178.873,0H21.127A21.151,21.151,0,0,0,0,21.127V178.873A21.151,21.151,0,0,0,21.127,200H178.873A21.151,21.151,0,0,0,200,178.873V43.66A4.225,4.225,0,0,0,195.775,39.434ZM8.451,21.127A12.691,12.691,0,0,1,21.127,8.451H95.775V95.775H8.451Zm183.1,157.746a12.691,12.691,0,0,1-12.676,12.676H21.127A12.691,12.691,0,0,1,8.451,178.873V104.225H95.775v69.014a4.225,4.225,0,1,0,8.451,0V104.225h87.324v74.648Z"
                    />
                  </g>
                </g>
                <g id="Group_16" data-name="Group 16">
                  <g id="Group_15" data-name="Group 15">
                    <path
                      id="Path_8"
                      data-name="Path 8"
                      d="M71.831,47.888H56.338V32.395a4.225,4.225,0,1,0-8.451,0V47.887H32.395a4.225,4.225,0,0,0,0,8.451H47.887V71.831a4.225,4.225,0,0,0,8.451,0V56.338H71.831a4.225,4.225,0,1,0,0-8.451Z"
                    />
                  </g>
                </g>
                <g id="Group_18" data-name="Group 18">
                  <g id="Group_17" data-name="Group 17">
                    <path
                      id="Path_9"
                      data-name="Path 9"
                      d="M167.605,132.395H128.169a4.225,4.225,0,1,0,0,8.451h39.436a4.225,4.225,0,1,0,0-8.451Z"
                    />
                  </g>
                </g>
                <g id="Group_20" data-name="Group 20">
                  <g id="Group_19" data-name="Group 19">
                    <path
                      id="Path_10"
                      data-name="Path 10"
                      d="M167.605,154.93H128.169a4.225,4.225,0,1,0,0,8.451h39.436a4.225,4.225,0,1,0,0-8.451Z"
                    />
                  </g>
                </g>
                <g id="Group_22" data-name="Group 22">
                  <g id="Group_21" data-name="Group 21">
                    <path
                      id="Path_11"
                      data-name="Path 11"
                      d="M58.088,147.887l10.955-10.955a4.226,4.226,0,0,0-5.975-5.976L52.112,141.912,41.157,130.956a4.225,4.225,0,0,0-5.975,5.976l10.954,10.955L35.181,158.843a4.225,4.225,0,0,0,5.975,5.976l10.955-10.955,10.955,10.955a4.225,4.225,0,1,0,5.975-5.976Z"
                    />
                  </g>
                </g>
                <g id="Group_24" data-name="Group 24">
                  <g id="Group_23" data-name="Group 23">
                    <path
                      id="Path_12"
                      data-name="Path 12"
                      d="M167.605,47.888H128.169a4.225,4.225,0,0,0,0,8.451h39.436a4.225,4.225,0,0,0,0-8.451Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </>
      );
    }
    case "clientManagement": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_3"
                  data-name="Rectangle 3"
                  width="200"
                  height="200"
                  transform="translate(495 53)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Client"
              transform="translate(-495 -53)"
              // clip-path="url(#clip-path)"
            >
              <path
                id="customer-care"
                d="M33.333,33.333A16.667,16.667,0,1,0,16.667,16.667,16.683,16.683,0,0,0,33.333,33.333Zm0-25A8.333,8.333,0,1,1,25,16.667,8.342,8.342,0,0,1,33.333,8.333ZM75,41.667A16.667,16.667,0,1,0,58.333,25,16.683,16.683,0,0,0,75,41.667Zm0-25A8.333,8.333,0,1,1,66.667,25,8.342,8.342,0,0,1,75,16.667Zm41.667,16.667A16.667,16.667,0,1,0,100,16.667,16.683,16.683,0,0,0,116.667,33.333Zm0-25a8.333,8.333,0,1,1-8.333,8.333A8.342,8.342,0,0,1,116.667,8.333Zm-66.15,61.65a25.515,25.515,0,0,1,49.817,0c.475,2.25-.575,5.017-4.083,5.017a4.163,4.163,0,0,1-4.067-3.317,17.193,17.193,0,0,0-33.517,0,4.166,4.166,0,0,1-8.158-1.692Zm66.15-28.317A25.391,25.391,0,0,1,141.575,61.65a4.06,4.06,0,0,1-4.083,5.017,4.223,4.223,0,0,1-4.067-3.317A17.038,17.038,0,0,0,116.667,50a17.371,17.371,0,0,0-6.733,1.342,4.165,4.165,0,1,1-3.2-7.692,25.619,25.619,0,0,1,9.933-1.983ZM8.425,61.65a25.585,25.585,0,0,1,34.842-18,4.165,4.165,0,1,1-3.2,7.692A17.493,17.493,0,0,0,33.333,50,17.037,17.037,0,0,0,16.575,63.35c-.408,1.967-2.158,3.592-4.067,3.317C9.133,66.183,7.95,63.908,8.425,61.65Zm184.75,18.8A21.157,21.157,0,0,0,178.1,75.017a20.8,20.8,0,0,0-14.492,6.817l-31.1,34.183A22.057,22.057,0,0,0,111.317,100H29.167A29.2,29.2,0,0,0,0,129.167v41.667A29.2,29.2,0,0,0,29.167,200H78.875a79.221,79.221,0,0,0,59.108-26.508L194.7,109.833a20.992,20.992,0,0,0-1.525-29.383Zm-4.692,23.842L131.767,167.95a70.892,70.892,0,0,1-52.892,23.717H29.167A20.857,20.857,0,0,1,8.333,170.833V129.167a20.857,20.857,0,0,1,20.833-20.833h82.142a13.684,13.684,0,0,1,2.042,27.217l-51.342,6.142A4.167,4.167,0,1,0,63,149.967l51.442-6.158a22.149,22.149,0,0,0,17.875-15.2l37.467-41.167a12.577,12.577,0,0,1,17.783-.825,12.635,12.635,0,0,1,.917,17.683Z"
                transform="translate(495.012 53)"
              />
            </g>
          </svg>
        </>
      );
    }

    case "company": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_7"
                  data-name="Rectangle 7"
                  width="200"
                  height="200"
                  transform="translate(495 295)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs>
            <g
              id="Company"
              transform="translate(-495 -295)"
              clip-path="url(#clip-path)"
            >
              <path
                id="city"
                d="M133.333,112.5a4.168,4.168,0,0,1-4.167,4.167h-8.333a4.167,4.167,0,0,1,0-8.333h8.333A4.168,4.168,0,0,1,133.333,112.5Zm29.167-4.167h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333Zm-33.333,33.333h-8.333a4.167,4.167,0,0,0,0,8.333h8.333a4.167,4.167,0,1,0,0-8.333Zm33.333,0h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333Zm-33.333-100h-8.333a4.167,4.167,0,0,0,0,8.333h8.333a4.167,4.167,0,1,0,0-8.333Zm33.333,0h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333ZM129.167,75h-8.333a4.167,4.167,0,1,0,0,8.333h8.333a4.167,4.167,0,1,0,0-8.333ZM162.5,75h-8.333a4.167,4.167,0,0,0,0,8.333H162.5a4.167,4.167,0,0,0,0-8.333ZM200,37.5v125A37.546,37.546,0,0,1,162.5,200H37.5A37.546,37.546,0,0,1,0,162.5V73.767A37.688,37.688,0,0,1,11.483,46.758L25.6,33.167a29.052,29.052,0,0,1,40.458,0L80.175,46.758a36.2,36.2,0,0,1,3.15,3.45v-12.7a37.546,37.546,0,0,1,37.5-37.5h41.667a37.546,37.546,0,0,1,37.5,37.5ZM83.333,73.767A29.32,29.32,0,0,0,74.4,52.758L60.283,39.167a20.75,20.75,0,0,0-28.9,0l-14.117,13.6A29.32,29.32,0,0,0,8.333,73.775v88.733A29.2,29.2,0,0,0,37.5,191.675H83.333V73.767ZM191.667,37.5A29.2,29.2,0,0,0,162.5,8.333H120.833A29.2,29.2,0,0,0,91.667,37.5V191.667H162.5A29.2,29.2,0,0,0,191.667,162.5Zm-137.5,70.833H37.5a4.167,4.167,0,1,0,0,8.333H54.167a4.167,4.167,0,1,0,0-8.333Zm0-33.333H37.5a4.167,4.167,0,1,0,0,8.333H54.167a4.167,4.167,0,1,0,0-8.333Zm0,66.667H37.5a4.167,4.167,0,0,0,0,8.333H54.167a4.167,4.167,0,0,0,0-8.333Z"
                transform="translate(495 294.996)"
              />
            </g>
          </svg>
        </>
      );
    }

    case "subscription": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_8"
                  data-name="Rectangle 8"
                  width="200"
                  height="200"
                  transform="translate(714 295)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Subscription_"
              data-name="Subscription "
              transform="translate(-714 -295)"
              // clip-path="url(#clip-path)"
            >
              <path
                id="subscription-alt"
                d="M199.992,37.5V54.164a37.544,37.544,0,0,1-37.5,37.5H129.161a4.166,4.166,0,1,1,0-8.333h33.332a29.2,29.2,0,0,0,29.165-29.165V37.5A29.2,29.2,0,0,0,162.493,8.333H37.5A29.2,29.2,0,0,0,8.333,37.5V54.164A29.2,29.2,0,0,0,37.5,83.33h8.333a4.166,4.166,0,1,1,0,8.333H37.5A37.544,37.544,0,0,1,0,54.164V37.5A37.544,37.544,0,0,1,37.5,0H162.493A37.544,37.544,0,0,1,199.992,37.5ZM147.96,157.8l-39.632-14.858V105.062c0-10.608-7.466-19.824-17.366-21.441A21.042,21.042,0,0,0,74.005,88.3a20.8,20.8,0,0,0-7.341,15.874v61.864l-1.15.558L51.581,155.51a20.831,20.831,0,0,0-28.415,30.465l13.666,12.9a4.138,4.138,0,0,0,5.691-6.008L28.915,179.942a12.5,12.5,0,0,1,17-18.341c.108.108,14.416,11.508,14.416,11.508A9.041,9.041,0,0,0,75,166.026V104.162A12.5,12.5,0,0,1,89.63,91.838C95.538,92.8,100,98.479,100,105.054v40.773a4.165,4.165,0,0,0,2.7,3.9L145.027,165.6c13.349,5.008,21.632,16.583,21.632,30.224a4.166,4.166,0,1,0,8.333,0c0-17.2-10.358-31.765-27.032-38.023Z"
                transform="translate(714.004 295)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "connectPay": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.99"
            height="14"
            viewBox="0 0 13.99 14"
          >
            <g
              id="Group_40542"
              data-name="Group 40542"
              transform="translate(22216.238 -2460)"
            >
              <path
                id="Path_28638"
                data-name="Path 28638"
                d="M770.136,664c.092.022.184.041.276.066a2.07,2.07,0,0,1,.95.541c.387.386.775.771,1.159,1.161a.3.3,0,0,0,.238.1q2.029,0,4.058,0h.172v6.06H767.2V669c-.339-.1-.654-.181-.963-.28a.915.915,0,0,1-.311-.167.751.751,0,0,0-.6-.119v.7H763V664h2.324v.435a.957.957,0,0,0,.612-.062c.277-.129.558-.249.837-.373Zm-3.252,2.616a1.288,1.288,0,0,0,.948.382,1.367,1.367,0,0,0,.932-.447c.042.051.073.1.111.135q.612.615,1.226,1.228a.468.468,0,1,0,.67-.652q-.759-.768-1.526-1.527a.451.451,0,0,0-.124-.065l.359-.374c.162.165.317.331.482.487a.285.285,0,0,0,.174.076c.565.006,1.13,0,1.694,0a1.153,1.153,0,0,0,.121-.015c-.293-.29-.572-.558-.841-.837a1.73,1.73,0,0,0-1.32-.548q-1.325.01-2.651,0a1.357,1.357,0,0,0-.679.164,1.9,1.9,0,0,1-.758.292c-.12.008-.241,0-.364,0v3.045c.113,0,.218.008.321,0a.563.563,0,0,1,.38.112,3.061,3.061,0,0,0,.464.257,1.69,1.69,0,0,0,.7.148c0-.345,0-.677,0-1.008,0-.089-.037-.122-.109-.161-.173-.094-.338-.2-.519-.315Zm9.642-.275h-5.984l-.025.035c.117.107.24.208.349.322a.315.315,0,0,0,.251.1q1.8,0,3.608,0h.173a1.081,1.081,0,0,0,.277.9,1.05,1.05,0,0,0,.882.266v1.87a.995.995,0,0,0-1.16,1.159h-5.6a1.058,1.058,0,0,0-.271-.888,1.093,1.093,0,0,0-.877-.274v-1.867a1,1,0,0,0,.967-.38c-.121-.12-.232-.234-.348-.342a.1.1,0,0,0-.09-.022,1.812,1.812,0,0,1-1,.245v3.994h8.849Zm-5.216,1.683a1.216,1.216,0,0,1,1.658.081,1.18,1.18,0,0,1-1.287,1.907,1.153,1.153,0,0,1-.683-.7,1.223,1.223,0,0,1,.081-.989.966.966,0,0,1-1.364-.134c-.086-.086-.17-.176-.263-.272a1.46,1.46,0,0,1-.846.5v.967a1.432,1.432,0,0,1,1.144,1.148h4.69c.225-.7.405-.88,1.158-1.157,0-.288,0-.579,0-.87,0-.027,0-.053-.007-.086a1.425,1.425,0,0,1-1.143-1.139h-3.106A1.109,1.109,0,0,1,771.311,668.024Zm-7.837-3.552v4.187h1.381v-4.187Zm9.321,4.43a.69.69,0,0,0-.689-.7.7.7,0,0,0-.709.7.708.708,0,0,0,.706.7A.7.7,0,0,0,772.8,668.9Z"
                transform="translate(-22979.238 1796)"
                // fill="#fff"
              />
              <path
                id="Path_28639"
                data-name="Path 28639"
                d="M833.158,985.223a1.04,1.04,0,0,1,.784-.628c.828-.213,1.651-.447,2.479-.659a3.466,3.466,0,0,1,.66-.086c.254-.014.51,0,.765,0a1.3,1.3,0,0,1,.751.208c.163.1.331.2.52.312v-.745h2.324v4.649h-2.32v-.341c-.209.081-.4.148-.578.225a1.652,1.652,0,0,1-.665.126q-1.544-.006-3.089,0a1.385,1.385,0,0,1-.738-.207q-2.083-1.252-4.171-2.5a.933.933,0,1,1,.908-1.63c.766.411,1.529.826,2.294,1.239Zm3.686.536c-.881.232-1.739.475-2.606.679a.894.894,0,0,1-1.1-.637.194.194,0,0,0-.081-.1c-.835-.454-1.671-.908-2.511-1.354a.54.54,0,0,0-.3-.047.444.444,0,0,0-.379.378.467.467,0,0,0,.249.49c1.405.842,2.81,1.686,4.22,2.52a.917.917,0,0,0,.439.116c1.061.01,2.123.007,3.184,0a.938.938,0,0,0,.306-.053c.257-.092.508-.2.763-.3a.125.125,0,0,0,.093-.141c0-.77,0-1.54-.005-2.31a.208.208,0,0,0-.084-.148q-.363-.231-.737-.442a.606.606,0,0,0-.266-.1,6.527,6.527,0,0,0-1.226.018c-.6.1-1.182.292-1.771.447q-.548.144-1.094.293a.474.474,0,0,0-.357.563.446.446,0,0,0,.551.339c.587-.145,1.171-.3,1.756-.456l.836-.221Zm4.134-1.671h-1.385V987.8h1.385Z"
                transform="translate(-23043.689 1485.72)"
                // fill="#fff"
              />
            </g>
          </svg>
        </>
      );
    }
    case "profile": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            data-name="Layer 1"
            viewBox="0 0 24 24"
            width="512"
            height="512"
          >
            <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-5,21.797v-.797c0-2.757,2.243-5,5-5s5,2.243,5,5v.797c-1.501.769-3.201,1.203-5,1.203s-3.499-.434-5-1.203Zm11-.582v-.215c0-3.309-2.691-6-6-6s-6,2.691-6,6v.215c-3.008-1.965-5-5.362-5-9.215C1,5.935,5.935,1,12,1s11,4.935,11,11c0,3.853-1.992,7.25-5,9.215ZM12,5c-2.206,0-4,1.794-4,4s1.794,4,4,4,4-1.794,4-4-1.794-4-4-4Zm0,7c-1.654,0-3-1.346-3-3s1.346-3,3-3,3,1.346,3,3-1.346,3-3,3Z" />
          </svg>
        </>
      );
    }
    case "reporting": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_5"
                  data-name="Rectangle 5"
                  width="200"
                  height="200"
                  transform="translate(41 295)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Reporting"
              transform="translate(-41 -295)"
              // clip-path="url(#clip-path)"
            >
              <path
                id="chart-line-up_3_"
                data-name="chart-line-up (3)"
                d="M20.833,191.667H200V200H20.833A20.862,20.862,0,0,1,0,179.167V0H8.333V179.167A12.515,12.515,0,0,0,20.833,191.667Zm120.833-150V50h44.108L125,110.775,91.667,77.442,34.55,134.558l5.892,5.892L91.658,89.233l33.333,33.333,66.675-66.675V100H200V41.667Z"
                transform="translate(41 295)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "teamMembers": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            {/* <defs>
              <clipPath id="clip-path">
                <rect
                  id="Rectangle_17"
                  data-name="Rectangle 17"
                  width="200"
                  height="200"
                  transform="translate(276 295)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
              </clipPath>
            </defs> */}
            <g
              id="Team_member_"
              data-name="Team member "
              transform="translate(-276 -295)"
              // clip-path="url(#clip-path)"
            >
              <path
                id="team-check"
                d="M145.827,91.663a54.164,54.164,0,1,0,54.164,54.164A54.227,54.227,0,0,0,145.827,91.663Zm0,100a45.831,45.831,0,1,1,45.831-45.831A45.891,45.891,0,0,1,145.827,191.659Zm27.915-57.139a4.163,4.163,0,0,1-.1,5.891l-22.524,21.782a15.687,15.687,0,0,1-21.857.017L117.9,150.985a4.166,4.166,0,0,1,5.858-5.925l11.35,11.208a7.316,7.316,0,0,0,10.183-.033l22.557-21.816a4.17,4.17,0,0,1,5.891.1ZM45.831,83.33a25,25,0,1,0-25-25A25.029,25.029,0,0,0,45.831,83.33Zm0-41.665A16.666,16.666,0,1,1,29.165,58.331,16.683,16.683,0,0,1,45.831,41.665Zm36.657,76.663a4.161,4.161,0,1,1-6.658,4.991,37.5,37.5,0,0,0-67.506,22.5,4.166,4.166,0,0,1-8.333,0,45.826,45.826,0,0,1,82.488-27.5ZM129.161,50a25,25,0,1,0-25-25A25.029,25.029,0,0,0,129.161,50Zm0-41.665A16.666,16.666,0,1,1,112.5,25,16.683,16.683,0,0,1,129.161,8.333ZM89.4,104.162c-4.083,0-4.666-3.225-3.975-5.416A45.855,45.855,0,0,1,152.077,72.8,4.163,4.163,0,1,1,147.91,80a37.53,37.53,0,0,0-54.539,21.232,4.162,4.162,0,0,1-3.975,2.917Z"
                transform="translate(276.008 295.004)"
              />
            </g>
          </svg>
        </>
      );
    }
    case "ScheduleCalendar": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19.044"
            height="19.044"
            viewBox="0 0 19.044 19.044"
          >
            <g id="Layer_3" transform="translate(0.2 0.2)">
              <path
                id="Path_27966"
                data-name="Path 27966"
                d="M18.351,6.32V4.7h-.809V6.32H15.248V4.7h-.809V6.32H11.983V4.7h-.809V6.32H5.4V23.344H24.044V6.32Zm-7.177.853V8.764h.809V7.144h2.482v1.62h.809V7.144h2.293v1.62h.809V7.144h4.884V19.706H6.209V7.173ZM6.209,22.491v-1.9H23.234v1.9Z"
                transform="translate(-5.4 -4.7)"
                fill="#4c96ce"
                stroke="#4c96ce"
                stroke-width="0.4"
              />
              <rect
                id="Rectangle_13472"
                data-name="Rectangle 13472"
                width="1.539"
                height="1.539"
                transform="translate(4.641 7.225)"
                fill="#4c96ce"
                stroke="#4c96ce"
                stroke-width="0.4"
              />
              <rect
                id="Rectangle_13473"
                data-name="Rectangle 13473"
                width="1.539"
                height="1.539"
                transform="translate(8.553 7.225)"
                fill="#4c96ce"
                stroke="#4c96ce"
                stroke-width="0.4"
              />
              <rect
                id="Rectangle_13474"
                data-name="Rectangle 13474"
                width="1.539"
                height="1.539"
                transform="translate(12.492 7.225)"
                fill="#4c96ce"
                stroke="#4c96ce"
                stroke-width="0.4"
              />
              <rect
                id="Rectangle_13475"
                data-name="Rectangle 13475"
                width="1.539"
                height="1.539"
                transform="translate(4.641 11.394)"
                fill="#4c96ce"
                stroke="#4c96ce"
                stroke-width="0.4"
              />
              <rect
                id="Rectangle_13476"
                data-name="Rectangle 13476"
                width="1.539"
                height="1.539"
                transform="translate(8.553 11.394)"
                fill="#4c96ce"
                stroke="#4c96ce"
                stroke-width="0.4"
              />
              <rect
                id="Rectangle_13477"
                data-name="Rectangle 13477"
                width="1.539"
                height="1.539"
                transform="translate(12.492 11.394)"
                fill="#4c96ce"
                stroke="#4c96ce"
                stroke-width="0.4"
              />
            </g>
          </svg>
        </>
      );
    }
    case "marketing": {
      return (
        <>
          <svg
            id="Layer_1"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m60.9 159.3h128.3c10.3 0 18.7-8.4 18.7-18.7v-79.1c0-10.3-8.4-18.7-18.7-18.7h-128.3c-10.3 0-18.7 8.4-18.7 18.7v79.1c-.1 10.3 8.3 18.7 18.7 18.7zm128.3-16h-128.3c-1.5 0-2.7-1.3-2.7-2.7v-74l61.8 51.2c1.5 1.2 3.3 1.8 5.1 1.8s3.6-.6 5.1-1.8l61.8-51.2v73.9c0 1.5-1.3 2.8-2.8 2.8zm-115.5-84.6h102.8l-51.5 42.6zm249.5 72.9h130.4c8.3 0 15.1-6.8 15.1-15.1v-101.4c.1-8.3-6.7-15.1-15.1-15.1h-130.4c-8.3 0-15.1 6.8-15.1 15.1v101.4c0 8.3 6.8 15.1 15.1 15.1zm.9-115.6h128.7v99.6h-128.7zm91.7 42.9-46.8-27c-2.5-1.4-5.5-1.4-8 0s-4 4.1-4 6.9v54.1c0 2.9 1.5 5.5 4 6.9 1.2.7 2.6 1.1 4 1.1s2.8-.4 4-1.1l46.8-27c2.5-1.4 4-4.1 4-6.9s-1.5-5.6-4-7zm-42.8 20.1v-26.4l22.8 13.2zm120.6 92.1h-133c-8.4 0-15.3 6.9-15.3 15.3v2.2h-48.7l-12.2-45.6c-1.9-7-6.4-12.9-12.7-16.6s-13.7-4.6-20.7-2.7c-12.7 3.4-20.9 15.3-20.2 27.9l-43.3 37.7c-1-.4-2-.6-3.1-.6h-134.6c-15.6 0-28.3 12.7-28.3 28.3v231h-10.4c-4.4 0-8 3.6-8 8v18.6c0 20.6 16.8 37.4 37.4 37.4h366.7c20.6 0 37.4-16.8 37.4-37.4v-18.6c0-4.4-3.6-8-8-8h-10.4v-143h67.4c8.4 0 15.3-6.9 15.3-15.3v-103.3c0-8.4-6.8-15.3-15.3-15.3zm-238.5-32c2.9-.8 5.9-.4 8.6 1.2 2.6 1.5 4.5 4 5.3 6.9l44.8 167.1c1.6 6-2 12.2-8 13.9-6 1.6-12.2-2-13.9-8l-44.8-167.2c-1.6-6.1 1.9-12.3 8-13.9zm-90.2 179.4c.3 1 .7 1.9 1.3 2.7l42.7 57.3-31.7 8.5-36.2-51.5-2.8-10.4 26.5-7.1zm-5.7-89.2 18.4 68.7-50.3 13.5c-.3 0-.6.1-1 .2h-.1c-1.4.2-2.7-.1-3.9-.8-1.5-.8-2.5-2.2-2.9-3.8l-15.1-56.5c-.9-3.3 1.1-6.8 4.4-7.7zm34.6 67.4-20-74.5 61-53.1 38.3 143zm234.9 177.9c0 11.8-9.6 21.4-21.4 21.4h-366.8c-11.8 0-21.4-9.6-21.4-21.4v-10.6h137.5v7.9c0 7.8 6.3 14.1 14.1 14.1h106.5c7.8 0 14.1-6.3 14.1-14.1v-7.9h137.5v10.6zm-256.1-10.7h102.6v6h-102.6zm237.7-16h-372.8v-230.9c0-6.8 5.5-12.3 12.3-12.3h120l-8.8 7.6-56.5 15.1c-11.9 3.2-18.9 15.4-15.8 27.3l15.1 56.5c2.4 8.9 9.8 15.1 18.4 16.3l3.6 13.5c.2.9.6 1.8 1.2 2.5l37.1 52.7c3 4.3 7.8 6.8 12.9 6.8 1.4 0 2.8-.2 4.2-.6l31.9-8.5c5.2-1.4 9.1-5.1 10.9-10.1 1.8-5.1.9-10.4-2.3-14.7l-41.2-55.3 7.1-1.9 90.8 17.7c4.7 9.2 14.1 15 24.3 15 2.3 0 4.7-.3 7.1-.9 14.5-3.9 23.2-18.9 19.3-33.5l-28.3-105.5h44.4v85.2c0 8.4 6.9 15.3 15.3 15.3h49.6v142.7zm82.6-158.9h-131.6v-101.9h131.6zm-111.9-50.9c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8c-4.4 0-8-3.6-8-8zm38.1 0c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8c-4.4 0-8-3.6-8-8zm38.2 0c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8c-4.5 0-8-3.6-8-8z" />
          </svg>
        </>
      );
    }
    case "plus": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-plus"
          >
            <path d="M5 12h14" />
            <path d="M12 5v14" />
          </svg>
        </>
      );
    }
    case "remove": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-trash-2"
          >
            <path d="M3 6h18" />
            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
            <line x1="10" x2="10" y1="11" y2="17" />
            <line x1="14" x2="14" y1="11" y2="17" />
          </svg>
        </>
      );
    }
    case "star": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-star"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </>
      );
    }
    case "starHalf": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-star-half"
          >
            <path d="M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2" />
          </svg>
        </>
      );
    }
    case "info": {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-info"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4" />
          <path d="M12 8h.01" />
        </svg>
      );
    }
    case "cross": {
      return (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-x"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </>
      );
    }
    default: {
      return <></>;
    }
  }
};

export default SvgIcons;
